<template>
  <div class="log-statistics" :class="{ 'app-region blank-t-v blank-l-h blank-r-h': !communityId }">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>设备名称</p>
          </a-col>
          <a-col>
            <a-input v-model="table.search.device_name" placeholder="请输入设备名称" allow-clear></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>设备码</p>
          </a-col>
          <a-col>
            <a-input v-model="table.search.name" placeholder="请输入设备唯一编码" allow-clear></a-input>
          </a-col>
        </a-row>
      </a-col>

      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>开锁时间</p>
          </a-col>
          <a-col>
            <a-range-picker v-model="table.search.time" class="app-block" show-time
              valueFormat="YYYY-MM-DD HH:mm:ss"></a-range-picker>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>开门方式</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.unlockType" class="app-block" placeholder="请选择开锁类型">
              <a-select-option value="face">{{unlockTypeText('face')}}</a-select-option>
              <a-select-option value="qrCode">{{unlockTypeText('qrCode')}}</a-select-option>
              <a-select-option value="tradCard">{{unlockTypeText('tradCard')}}</a-select-option>
              <a-select-option value="bleCard">{{unlockTypeText('bleCard')}}</a-select-option>
              <a-select-option value="password">{{unlockTypeText('password')}}</a-select-option>
              <a-select-option value="remoteOpen">{{unlockTypeText('remoteOpen')}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <!-- <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>设备类型</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.deviceType" class="app-block" placeholder="请选择设备类型">
              <a-select-option :value="1">{{deviceTypeText(1)}}</a-select-option>
              <a-select-option :value="2">{{deviceTypeText(2)}}</a-select-option>
              <a-select-option :value="3">{{deviceTypeText(3)}}</a-select-option>
              <a-select-option :value="4">{{deviceTypeText(4)}}</a-select-option>
              <a-select-option :value="10">{{deviceTypeText(10)}}</a-select-option>
              <a-select-option :value="14">{{deviceTypeText(14)}}</a-select-option>
              <a-select-option :value="-1">{{deviceTypeText(-1)}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>人员类型</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.unlockPersonType" class="app-block" placeholder="请选择人员类型">
              <a-select-option :value="1">{{unlockPersonTypeText(1)}}</a-select-option>
              <a-select-option :value="2">{{unlockPersonTypeText(2)}}</a-select-option>
              <a-select-option :value="3">{{unlockPersonTypeText(3)}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col> -->

      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
          <!-- <a-button @click="exportTable">导出</a-button> -->
          <!-- <a target="_blank" :href="$exportUrl(`/community/entrance/unlock-log/export?community_id=${communityId}&devCode=${table.search.number}&devName=${table.search.name}&start_time=${table.search.time[0] || ''}&end_time=${table.search.time[1] || ''}&unlockStatus=${table.search.unlockType}&deviceType=${table.search.deviceType}&person_type=${table.search.unlockPersonType}`)">
            <a-button>导出</a-button>
          </a> -->
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id"
      :pagination="table.page" @change="handlePageChange">
      <span slot="face" slot-scope="text, data" v-if="data.face">
        <dy-image :src="data.face" :preview="true"></dy-image>
      </span>
    </a-table>
  </div>
</template>

<script>
import {
  unlockTypeText,
  deviceTypeText,
  unlockPersonTypeText
} from '@/io/dict.js';
import DeviceService from '@/io/device.js';
import { mapState } from 'vuex';

export default {
  name: 'LogStatistics',
  props: {
    communityId: {
      type: Number,
      default: null
    },
  },
  data() {
    let self = this;
    return {
      unlockTypeText,
      deviceTypeText,
      unlockPersonTypeText,
      table: {
        loading: false,
        search: {
          number: null,
          name: null,
          time: [],
          unlockType: [],
          deviceType: [],
          unlockPersonType: []
        },
        page: {
          total: 0,
          current: 1,
          pageSize: 10,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal() {
            return `共${self.table.page.total}条`;
          }
        },
        data: [],
        columns: [

          {
            title: '设备名称',
            dataIndex: 'device_name'
          },
          {
            title: '设备码',
            dataIndex: 'name'
          },
          {
            title: '开锁类型',
            dataIndex: 'type'
          },
          {
            title: '人脸照片',
            scopedSlots: { customRender: "face" }
          },
          {
            title: '开锁时间',
            dataIndex: 'open_time'
          },

          // {
          //   title: '设备类型',
          //   dataIndex: 'deviceTypeText'
          // },
          // {
          //   title: '人员类型',
          //   dataIndex: 'unlockPersonTypeText'
          // }
        ]
      }
    }
  },
  computed:{
    ...mapState(['community'])
  },
  watch: {
    communityId: {
      handler(newValue, oldValue) {
        if (newValue || this.$getCookie('communityId')) {
          this.searchTable();
        }
      },
      immediate: true
    }
  },
  activated() {
    if (this.communityId) {
      this.initData();
    }
  },
  methods: {
    searchTable() {
      this.table.page.current = 1;
      this.initData();
    },
    resetSearchTable() {
      this.table.search = {
        number: null,
        name: null,
        time: [],
        unlockType: [],
        deviceType: [],
        unlockPersonType: []
      };
      this.searchTable();
    },
    handlePageChange(page) {
      this.table.page.current = page.current;
      this.table.page.pageSize = page.pageSize;
      this.initData();
    },
    initData() {
      this.table.loading = true;
      this.$emit('total', 0);
      return DeviceService.log(
        this.communityId || this.community.id,
        this.table.search.device_name,
        this.table.search.name,
        this.table.search.time[0],
        this.table.search.time[1],
        this.table.search.unlockType,
        // this.table.search.deviceType,
        // this.table.search.unlockPersonType,
        this.table.page.current,
        this.table.page.pageSize
      ).then(res => {


        this.table.data = res.data.map(val => {
          val.type = unlockTypeText(val.type);
          // val.deviceTypeText = deviceTypeText(val.deviceType);
          // val.unlockPersonTypeText = unlockPersonTypeText(val.person_type);
          return val;
        });
        this.table.page.total = res.meta.pagination.total;
        this.$emit('total', res.meta.pagination.total);
      }).catch(err => { }).finally(() => {
        this.table.loading = false;
      });
    },
    exportTable() {
      DeviceService.exportLogList(
        this.communityId,
        this.table.search.number,
        this.table.search.name,
        this.table.search.time[0],
        this.table.search.time[1],
        this.table.search.unlockType,
        this.table.search.deviceType,
        this.table.search.unlockPersonType
      );
    }
  },
}
</script>

<style lang="less" scoped>

</style>